import dayjs from "dayjs";
export function getDaysDiff(days: number) {
  return dayjs().subtract(days, "day").format("MM-DD-YYYY");
}

export function toDate(date?: string | null) {
  if (date) {
    return dayjs(date).format("MM-DD-YYYY");
  }
  return "";
}
